export {default} from 'netxcore@netx/core-auth//controller';

import {appRouter} from '@netx/core-next/instance/router';
import Collection from '@netx/core/lib/netx-collection';
import {localStore} from '@netx/core-next/instance/localStore';
import {session} from '@netx/core-auth/collections/singleton/session';
import {userProfile} from '@netx/core-user/collections/singletons/userProfile';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {whenReady} from '@netx/core-next/whenReady';
import {currentPortal} from '@netx/core-cms/singletons/currentPortal';
import customConfig from './config';

dispatcher.once('auth:init', function (options) {
	/**
	 * Invalid token
	 * @event modeule:auth#auth:token:invalid
	 */
	dispatcher.once('auth:token:invalid', function () {
		localStore.remove(customConfig.POST_LOGIN_HASH_NAME);
	});
	/**
	 * Valid token
	 * @event modeule:auth#auth:token:valid
	 */
	dispatcher.once('auth:token:valid', function () {
		localStore.remove(customConfig.POST_LOGIN_HASH_NAME);
	});

	session.configured.then(function (props) {
		dispatcher.once('app:initialized', function () {
			/**
			 * User login
			 * @event module:auth#auth:user:login
			 * @fires module:auth#auth:user:login:expired
			 * @fires module:auth#auth:user:login:show
			 */
			dispatcher.off('auth:user:login');
			dispatcher.on('auth:user:login', function (isRouted) {
				// REMOVE THIS override when saml is in clean

				if (session.sessionExpired() && session.get('loginMsg') === '') {
					dispatcher.trigger('auth:user:login:expired');
				}

				// Wait for app ready
				whenReady(function () {
					// Show login
					dispatcher.trigger('auth:user:login:show', {
						model: session,
						collection: new Collection(),
						isRouted: isRouted,
						routeMatch: new RegExp(/^login/),
					});
				}, Netx.auth);
			});

			/**
			 * @event module:auth#auth:user:logout:routed
			 * @fires module:app#app:stop
			 * @fires module:app#app:alert
			 */
			dispatcher.off('auth:user:logout');
			dispatcher.on('auth:user:logout', function () {
				// if no session, getUser().logout() gets loopy
				if (!session.getKey()) {
					dispatcher.trigger('app:logout:success');
					return;
				}

				userProfile.logout().then(
					function () {
						dispatcher.trigger('app:logout:success');
					},
					function (err) {
						// Session ended before we logged out? Just as good.
						dispatcher.trigger('app:logout:success');
					},
				);
			});
			dispatcher.on('app:logout:success', function () {
				// Router navigation needs to occur before 'app:stop' is triggered or url redirection
				appRouter.navigate('');

				// THEM-557 - logout redirect
				const logoutUrl = currentPortal.get('logoutUrl');
				// the way the app works, we cannot route them to a hash within the portal
				// the app needs to be uninitialized and when that happens, you have no session, no nothing
				// so no matter what may come after the `#` here, you are going to the login page.
				if (
					logoutUrl.length &&
					!logoutUrl.includes(
						`${window.location.host}${window.location.pathname}`,
					)
				) {
					window.location = window.location.href = logoutUrl;
				} else {
					// Trigger application shutdown
					dispatcher.trigger('app:stop');
				}
			});

			/**
			 * @event module:auth#auth:user:password:change:success
			 * @fires module:app#app:alert
			 */
			// dispatcher.off('auth:user:password:change:success'
			dispatcher.off('auth:user:password:change:success');
			dispatcher.on(
				'auth:user:password:change:success',
				function () {
					dispatcher.trigger(
						'app:passiveAlert',
						i18n.t('i18n.passwordChangedLogIn'),
					);
					appRouter.navigate('login', {trigger: true});
				},
				window,
			);
		});
	});
});
